var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartCombo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chart--combo_svg__clip0_61530_7386)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21v-9h-6v9h-3V9h-6v12H3V1.5H1.5V21A1.5 1.5 0 003 22.5h19.5V21h-2.25zm-10.5 0h-3V10.5h3V21zm9 0h-3v-7.5h3V21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.088 10.5a1.49 1.49 0 01-.884-.29L8.402 4.49 6.18 7.5l-1.203-.895 2.235-3a1.498 1.498 0 012.062-.334L17.09 9l2.704-3.646 1.204.893-2.703 3.646a1.5 1.5 0 01-1.207.606z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chart--combo_svg__clip0_61530_7386"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgChartCombo;